'use strict';
import React from 'react';
import ReactDom from 'react-dom';
import menuAction from '../actions/menuAction';
import menuStore from '../stores/menuStore';
import ModalGeneral from './modalGeneral';
import userStore from '../stores/userStore';
import genFunction from '../functions/genFunction';

class SideMenu extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
        this.handleTitleClick = this.handleTitleClick.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onUserChange = this.onUserChange.bind(this);
        this.state = {
            activities: [
                { menuId: 1, title: "Attendance", url: "/attendance" },
                { menuId: 2, title: "Journey Planner", url: "/journeyPlanner" },
                { menuId: 3, title: "Estate Manager", url: "/estate" },
                { menuId: 4, title: "Incident Report", url: "/report" },
                { menuId: 5, title: "Leave Application", url: "/leave" },
                { menuId: 6, title: "Leave Summary", url: "/leaveInfo" },
                { menuId: 7, title: "Employee Detail", url: "/userProfile" },
                { menuId: 8, title: "Contractor/Condo Detail", url: "/contractor" },
            ],
            settings: [
                { menuId: 9, title: "Journey Management", url: "/journeySetting", permissionId: 10 },
                { menuId: 10, title: "Employee Management", url: "/userSetting", permissionId: 5 },
                { menuId: 16, title: "Team Management", url: "/teamSetting", permissionId: 11 },
                { menuId: 11, title: "Contractor/Condo Management", url: "/contractorSetting", permissionId: 6 },
                { menuId: 12, title: "Master CheckList", url: "/checkListSetting", permissionId: 7 },
                { menuId: 17, title: "Holiday Management", url: "/holidaySetting", permissionId: 8 },
                { menuId: 13, title: "Leave Management", url: "/leaveSetting", permissionId: 8 },
                { menuId: 15, title: "Location Management", url: "/checkPtsSetting", permissionId: 0 },
                { menuId: 14, title: "Permission Management", url: "/permissionSetting", permissionId: 9 },
            ],
            selectedId: menuStore.getState().selectedId,
            isActivityShow: menuStore.getState().isActivityShow,
            isSettingShow: menuStore.getState().isSettingShow,
            screenWidth: 500,
            screenHeight: 500,

            permission: userStore.getState().permission,
            subordinate: userStore.getState().subordinate,
            userId: userStore.getState().staffId,
        }
    }
    static defaultProps = {
        active: {
            visibility: "visible",
            height: "100%"
        },
        inActive: {
            visibility: "hidden",
            height: "0"
        }
    };
    componentDidMount() {
        menuStore.listen(this.onChange);
        userStore.listen(this.onUserChange);
        this.setState({
            screenWidth: document.documentElement.clientWidth,
            screenHeight: document.documentElement.clientHeight
        });

    }
    componentWillUnmount() {
        menuStore.unlisten(this.onChange);
        userStore.unlisten(this.onUserChange);
    }
    onChange(state) {
        this.setState({
            selectedId: state.selectedId,
            isActivityShow: state.isActivityShow,
            isSettingShow: state.isSettingShow
        });
    }
    onUserChange(state) {
        this.setState({
            permission: state.permission,
            subordinate: state.subordinate,
            userId: state.staffId
        });
    }
    handleTitleClick(e) {
        let index = parseInt(e.target.getAttribute("data-index"));
        if (index == 0) {
            menuAction.activityShow(!this.state.isActivityShow);
        } else if (index == 1) {
            menuAction.settingShow(!this.state.isSettingShow);
        }
    }
    handleClick(e) {
        let target = e.target;
        let selectedId = parseInt(target.getAttribute('data-id'));
        let url = target.getAttribute('data-url');
        if (this.state.selectedId != selectedId) {
            this.navigateOtherPage(url);
            menuAction.pageNumber(selectedId);
            menuAction.activityShow(false);
            menuAction.settingShow(false);
        }
    }
    navigateOtherPage(url) {
        this.props.history.push(url);
    }

    renderList(data) {
        let { userId } = this.state;
        if (userId && userId.includes("TG0") && userId != "ITG001") {
            data = data.filter((menu) => {
                return [1, 5, 6, 7].indexOf(menu.menuId) > -1;
            })
        } else if (userId == "ITG001") {
            data = data.filter((menu) => {
                return [1, 4, 5, 6, 7].indexOf(menu.menuId) > -1;
            })
        }
        data = data.filter((menu) => {
            return (genFunction.hasPermission(this.state.permission, menu.permissionId));
        });

        return data.map((menu, index) => {
            let isSelected = this.state.selectedId == menu.menuId ? true : false;
            return (
                <a className={"list-group-item " + (isSelected ? "active" : "")}
                    onClick={this.handleClick}
                    data-id={menu.menuId}
                    data-url={menu.url}
                    key={index}>
                    {menu.title}
                </a>
            );
        })
    }
    renderSetList(data, category) {
        data = data.filter((menu) => {
            return (genFunction.hasPermission(this.state.permission, menu.permissionId));
        });

        return data.map((menu, index) => {
            let isSelected = this.state.selectedId == menu.menuId ? true : false;
            return (
                <a className={"list-group-item " + (isSelected ? "active" : "")}
                    onClick={this.handleClick}
                    data-id={menu.menuId}
                    data-url={menu.url}
                    key={index}>
                    {menu.title}
                </a>
            );
        })

    }
    handleScroll(e) {
        e.preventDefault();
        e.stopPropagation();
        if (e.deltaY > 0) {
            //scroll down
            ReactDom.findDOMNode(this.refs.sideNav).scrollTop += 50;
        } else {
            //scroll up
            ReactDom.findDOMNode(this.refs.sideNav).scrollTop -= 50;
        }
    }
    render() {

        let styleActivity = '';
        let styleSetting = '';
        let menuHeight = "auto";
        let overflow = "visible";
        if (this.state.screenWidth < 768) {
            if (this.state.isSettingShow) {
                styleSetting = this.props.active
            } else {
                styleSetting = this.props.inActive;
            }
            if (this.state.isActivityShow) {
                styleActivity = this.props.active
            } else {
                styleActivity = this.props.inActive;
            }
        } else {
            menuHeight = (this.state.screenHeight - 60) + "px";
            overflow = "auto";
        }
        let setting = this.renderSetList(this.state.settings, 1);
        let st;

        if (setting.length > 0) {
            st = (
                <div>
                    <div className="setting-title" data-index="1" onClick={this.handleTitleClick}>Settings</div>
                    <div id="nav-setting" className="sm-wp">
                        <div className="list-group" style={{ visibility: styleSetting.visibility, height: styleSetting.height }}>
                            {setting}
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="col-sm-4 col-md-2 ">
                <div className="a4-nav" ref="sideNav" onWheel={this.handleScroll}
                    style={{ height: menuHeight, overflow: overflow }} >
                    <div className="setting-title" data-index="0" onClick={this.handleTitleClick}>Activities</div>
                    <div id="sm-categories" className="sm-wp">
                        <div className="list-group" style={{ visibility: styleActivity.visibility, height: styleActivity.height }}>
                            {this.renderList(this.state.activities, 0)}
                        </div>
                    </div>
                    {st}
                </div>
                <ModalGeneral />
            </div>
        );
    }
}
export default SideMenu;


// WEBPACK FOOTER //
// ./app/components/sideMenu.js